import Profile from '@/modules/profile/pages/profile/profiles.page.vue';
import ProfileRegister from '@/modules/profile/pages/profile-register/profiles-register.page.vue';

declare const process: any;

export const PROFILE_ACCESS_ROUTES = Object.freeze({
    PROFILE: 'profiles-route',
    PROFILE_REGISTER: 'profiles-register',
});

export const profileRoutes = [
    {
        path: `${process.env.BASE_URL}profile`,
        component: () => import('@/layout/default.layout.vue'),
        children: [
            {
                path: '',

                // name: PROFILE_ACCESS_ROUTES.PROFILE,
                component: Profile,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                       // name: PROFILE_ACCESS_ROUTES.PROFILE_REGISTER,
                        component: ProfileRegister,
                    },
                ],
            },
        ],
    },
];
